/**
 * Program Summary Service
 * Register Angular Service for the Status Sumamry
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 * @return    Directive
 */
import angular from 'angular';

angular.module('flsServices').directive('highChart', function () {
    return {
        restrict: 'E',
        template: '<div></div>',
        scope: {
            options: '=',
            series:'='
        },
        link: function (scope, element) {
            Highcharts.chart(element[0], _.assign(scope.options, {series:scope.series}));
        }
    };
})
